import './style/index.css';
import '@usercentrics/preference-management-embeddable-components/dist/styles.css';
import App from './components/app';

export default App;
